/*rutas Orders*/
export default [
	{
		path: '/',
		name:'DiMenu',
		view: 'Orders',
		folder: 'views/dimenu',
	}
];